import { size } from 'lodash';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { emitter } from '../../../utils/emitter';
import _ from 'lodash'; // thu vien giup cac hang viet ngan gon hon
class ModalEditProduct extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            title: '',
            shortDescription: '',
            description: '',
            originalPrice: '',
            salePrice: '',
            isPromotion: '',
            promotionPercent: '',
            isFreeShip: '',
            category: '',
            thumbnail: '',
            color: '',
            size: '',
            model: '',
            country: '',
            originalLink: '',

        }

    }

    componentDidMount() {
        // console.log('Did mount edit Product: ', this.props.currentProduct)
        let product = this.props.currentProduct;
        if (product && !_.isEmpty(product)) {
            this.setState({
                name: product.name,
                title: product.title,
                shortDescription: product.shortDescription,
                description: product.description,
                originalPrice: product.originalPrice,
                salePrice: product.salePrice,
                isPromotion: product.isPromotion,
                promotionPercent: product.promotionPercent,
                isFreeShip: product.isFreeShip,
                category: product.category,
                thumbnail: product.thumbnail,
                color: product.color,
                size: product.size,
                model: product.model,
                country: product.country,
                originalLink: product.originalLink,
                id: product.id
            })
        }
    }
    toggle = () => {
        this.props.tooglefromParent()
    }
    handleOnchangeInput = (event, id) => {
        // bad code this.state[id] = event.target.value , ko nen update truc tiep
        // good code, thong qua 1 bien trung gian
        let copyState = { ...this.state }; // copy state moi
        copyState[id] = event.target.value
        this.setState({
            ...copyState
        }, () => { // callback function

        })
        // console.log("copyState: ", copyState)
        // console.log(event.target.value, id)
    }
    checkValideInput = () => {
        let arrInput = [
            'name',
            'title',
            'shortDescription',
            'description',
            'originalPrice',
            // 'salePrice',
            // 'isPromotion',
            'promotionPercent',
            // 'isFreeShip',
            'thumbnail',
            'color',
            'originalLink',
        ];
        let isValide = true;
        for (let i = 0; i < arrInput.length; i++) { // neu dung vong lap MAP thi ko the dung break, foreach

            if (!this.state[arrInput[i]]) {
                isValide = false
                alert("Missing parameters" + arrInput[i]);
                break;
            }
        }
        return isValide
    }
    handleEditProduct = () => {
        let isValide = this.checkValideInput();
        if (isValide == true) {
            this.props.editCurrentProduct(this.state)
        }


        // console.log("data modal edit Product: ", this.state)
    }

    render() {
        // console.log('check child props:', this.props);
        // console.log('check child open modal:', this.props.currentProduct);
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.toggle}
                className="modal-product-container"
                size="lg"
                centered
            >
                <ModalHeader toggle={this.toggle}>Edit Product</ModalHeader>
                <ModalBody>
                    <div className='modal-product-body'>

                        <div className='input-container'>
                            <label>Name: </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter product name"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'name')
                                }}
                                value={this.state.name}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Title: </label>
                            <input
                                type="text"
                                name="title"
                                placeholder="Enter title"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'title')
                                }}
                                value={this.state.title}
                            />
                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Discount: %</label>
                            <input
                                type="text"
                                name="promotionPercent"
                                placeholder="Enter discount"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'promotionPercent')
                                }}
                                value={this.state.promotionPercent}
                            />
                        </div>
                        <div className='input-container'>
                            <label>Color: </label>
                            <input
                                type="text"
                                name="color"
                                placeholder="Enter color of the product"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'color')
                                }}
                                value={this.state.color}
                            />
                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Location: </label>
                            <select name="country" id="country" class="form-control">
                                <option selected>Choose Country</option>
                                {this.props.countries && this.props.countries.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={index}> {item.countryName} </option>

                                    )
                                })}

                            </select>
                        </div>
                        <div className='input-container'>
                            <label>Price: </label>
                            <input
                                type="text"
                                name="originalPrice"
                                placeholder="Enter price"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'originalPrice')
                                }}
                                value={this.state.originalPrice}
                            />

                        </div>

                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container'>
                            <label>Category: </label>
                            <select name="category" id="category" class="form-control">
                                <option selected>Choose Category</option>
                                {this.props.categories && this.props.categories.map((item, index) => {
                                    // console.log('check map', item, index);
                                    return (
                                        <option value={index}> {item.categoryName} </option>

                                    )
                                })}
                            </select>
                        </div>
                        <div className='input-container'>
                            <label>Select image:</label>
                            <input type="file" id="img" name="img" accept="file_extension|audio/*|video/*|image/*|media_type" />
                            {/* <input /> */}
                        </div>

                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Thumbnail: </label>
                            <input
                                type="text"
                                name="thumbnail"
                                placeholder="Enter thumbnail"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'thumbnail')
                                }}
                                value={this.state.thumbnail}
                            />

                        </div>
                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Original link: </label>
                            <input
                                type="text"
                                name="originalLink"
                                placeholder="Enter original link of the product"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'originalLink')
                                }}
                                value={this.state.originalLink}
                            />

                        </div>


                    </div>
                    <div className='modal-product-body'>
                        <div className='input-container max-width-input'>
                            <label>Short Description: </label>
                            <input
                                type="text"
                                name="shortDescription"
                                placeholder="Enter short description"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'shortDescription')
                                }}
                                value={this.state.shortDescription}
                            />
                            <label>Description: </label>
                            <textarea
                                type="text"
                                name="description"
                                placeholder="Enter description"
                                onChange={(event, id) => {
                                    this.handleOnchangeInput(event, 'description')
                                }}
                                value={this.state.description}
                            />

                        </div>

                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button className='px-2' color="primary" onClick={this.handleEditProduct}>Save</Button>{' '}
                    <Button className='px-2' color="secondary" onClick={this.toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditProduct);


